import React from "react";
import { observer, inject } from "mobx-react";
import { PropTypes } from "prop-types";
import { useQuery } from "@apollo/client";
import { RANDOM_MOBILE_TARIFFS } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { pipe } from "Utils";
import { ShouldAddConvergentProvider } from "providers/shouldAddConvergentProvider";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";
import MobileTariffList from "ComponentsUI/MobileTariffList";

const RandomMobileTariffListContainer = (props) => {
	const {
		ApplicationModel: { text },
		seoBlock,
		textHeader,
	} = props;
	const {
		params: { regionUrl },
	} = useWithDefaultParams();

	const { data, loading } = useQuery(RANDOM_MOBILE_TARIFFS, {
		variables: {
			region_url: regionUrl,
			mobileTag: "bezlimitnyj-internet",
			limitTariff: 4,
			providerJoin: true,
		},
		notifyOnNetworkStatusChange: true,
	});

	if (loading) {
		return null;
	}

	if (data?.randomMobileTariffs?.data?.length) {
		let tariffs = data.randomMobileTariffs.data;

		return (
			<>
				<HeaderTextSeo header={seoBlock?.seoHeader || textHeader} text={seoBlock?.seoText} />
				<ShouldAddConvergentProvider value={true}>
					<MobileTariffList tariffs={tariffs} text={text} transfer={true} />
				</ShouldAddConvergentProvider>
			</>
		);
	} else {
		return null;
	}
};

RandomMobileTariffListContainer.propTypes = {
	seoBlock: PropTypes.object,
	textHeader: PropTypes.string,
};

export default pipe(observer, inject("ApplicationModel"))(RandomMobileTariffListContainer);
